import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill';
import BaiduMap from 'vue-baidu-map'
// import VueLazyLoad from 'vue-lazyload'
import MetaInfo from 'vue-meta-info'
import VideoPlayer from 'vue-video-player'
// import FooterView from '@/components/Footer.vue';
Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(VideoPlayer);

import {
	data
} from '@/assets/Utils/filter';

Vue.filter('data', data);



Vue.config.productionTip = false;
/*百度统计*/
router.afterEach(() => {
	setTimeout(() => {
		var _hmt = _hmt || [];
		(function() {
			var hm = document.createElement("script");
			hm.src = "https://hm.baidu.com/hm.js?cc4065164ffddf36f20fdd6a626d4af6";
			var s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(hm, s);
		})();
	}, 0);
});

Vue.use(BaiduMap, {
	ak: 'PlhFWpA02aoURjAOpnWcRGqw7AI8EEyO'
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
